define('views/modules/calendar/animated-session/exercise/exercise-duplicate-modal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    // collections
    'collections/calendar/session/animations',
    // models
    'models/calendar/session/animation',
    // views
    'views/parts/modal/modal',
    'views/modules/calendar/animated-session/animation/lists/animation-list',
    // templates
    'text!templates/modules/calendar/animated-session/exercise/exercise-duplicate-modal.html'

], function(
    // Libs
    _, Backbone, Mustache, U, i18n,
    // collections
    CAnimations,
    // models
    MAnimation,
    // views
    VModal,
    VAnimationList,
    // templates
    TExerciseDuplicateModal
) {

    var VExerciseDuplicateModal = VModal.extend({
        template: TExerciseDuplicateModal,

        regions: {
            list: ".animation-list",
        },

        modal: function() {
            return {
                title: i18n.t("Duplicate exercise data"),
                className: "exercise-duplicate-modal",
            };
        },

        initialize: function(options) {
            options = options || {}; // additional options passed to the constructor.

            this.collection = new CAnimations(null, {
                // overriden model to enable duplicate
                model: MAnimation.extend({
                    idAttribute: "none", // whatever that won't be in the attrs hash.
                })
            });

            this.view = {
                list: new VAnimationList({
                    fetch: false,
                    sortable: false,
                    collection: this.collection,
                }),
            };

            this.listenTo(this.collection, 'update', this.onCollectionUpdate);
        },

        render: function() {
            var html = Mustache.render(this.template, Mustache.getContext(
                {
                    modalSubtitle: i18n.t("messages:message-copy-exercise-data", { exerciseName: this.source.attributes._animation.name }) 
                }
            ));
            
            this.$el.empty().append(html);

            this.generateZones()
                .assign(this.view.list, this.zone.$list)
                .renderModal();

            return this;
        },

        resetModal: function(sourceExercise, models) {
            this.source = sourceExercise;

            this.render();
            this.collection.reset(_.map(models, function(model) {
                return _.extend(_.clone(model.getAnimation()), {
                    _exercise: model,
                    _disabled: Boolean(sourceExercise.is(model)) || model.isCardio()
                });
            }, this));

            return this;
        },

        ////////////
        // events //
        ////////////
        onConfirm: function(confirmed) {
            if (!confirmed) return;

            var selectedExercises = this.view.list.getSelectedAnimations();
            this.view.list.reset();

            if (this.source.isWeight()) {
                _.each(selectedExercises, function(animation) {
                    // make a new clone for each selected exercise.
                    animation.get('_exercise')
                        .convertToWeight(
                            this.source.clone({ deep: true }).toJSON());
                }, this);
            } else if (this.source.isCardio()) {
                // data = this.source.getPhases().toJSON();
                // _.each(selectedExercises, function(animation) {
                //     animation.get('_exercise').getPhases().reset(data);
                // });
            }

        },

    });

    return VExerciseDuplicateModal;

});

